import { useEffect, useMemo, useState } from 'react';
import { supabaseClient } from '../config/supabase';

// BL-177 PR C0: who may EDIT / DELETE / MERGE / IMPORT / EXPORT company contacts. The database decides (crm_can_manage_company_contacts:
// company admins, platform admins, and holders of CRM "manage" at that company); this only asks, so the buttons match what RLS will allow.
// Returns the set of entity ids the caller may manage. Empty until answered, so nothing flashes on that should not.
export default function useCanManageCompanyContacts(entityIds) {
    const key = useMemo(() => [...new Set((entityIds || []).filter(Boolean))].sort().join(','), [entityIds]);
    const [allowed, setAllowed] = useState(() => new Set());
    useEffect(() => {
        let cancelled = false;
        const ids = key ? key.split(',') : [];
        if (!ids.length) { setAllowed(new Set()); return undefined; }
        Promise.all(ids.map(async (id) => {
            const { data, error } = await supabaseClient.rpc('crm_can_manage_company_contacts', { p_entity: id });
            return !error && data === true ? id : null;
        })).then((result) => { if (!cancelled) setAllowed(new Set(result.filter(Boolean))); });
        return () => { cancelled = true; };
    }, [key]);
    return allowed;
}
